import registry from "js/api/registry"

export default (name, func) => registry[name]().then(func)
